// Module
var code = "<md-content class=\"animated fadeIn\"> <div layout=\"row\" layout-align=\"center center\" class=\"nets-logout-container\"> <md-progress-circular class=\"form-spinner\" md-mode=\"indeterminate\"> </md-progress-circular> </div> </md-content>";
// Exports
export default code;